import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { isError } from "react-query"
import { StockImportError, StockImportFormAttributes, StockNewImportModalProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { Service } from "../../state/inventory/imports/service"
import { EXPORT_TYPE, IMPORT_FROM } from "../../state/product/Types"
import { STOCK_IMPORT_MODAL_MESSAGES } from "../../utils/inventory"
import { createStockImportDto, createStockImportFromIntegrationDto } from "../../utils/inventory/utils"
import StockNewImportForm from "../forms/StockNewImportForm"
import "../styles/StockNewImportModalStyles.scss"

const StockNewImportModalComponent = (props: StockNewImportModalProps & IntlProps) => {
    const [errors, setErrors] = useState<StockImportError>({
        importType: "",
        inventoryLocation: "",
        file: "",
        importFrom: "",
        integration: "",
    })
    const [form, setForm] = useState<StockImportFormAttributes>({
        inventoryLocation: "",
        importType: "",
        notes: "",
        file: "",
        importFrom: "",
        integration: "",
    })
    
    const handleFormFieldChangeCallback = (field: string, value: string) => {
        setForm(prevForm => ({
            ...prevForm,
            [field]: value
        }))

        if (errors[field]) {
            setErrors({
                ...errors,
                [field]: null
            })
        }
    }

    const findFormErrors = () => {
        const { inventoryLocation, file, importType, importFrom, integration } = form
        const newErrors = { inventoryLocation: "", file: "", importType: "", importFrom: "", integration : ""}
        const isImportTypeUndefined = !importType || importType.trim().length === 0
        const isImportFromUndefined = importType == EXPORT_TYPE.INVENTORY_LEVELS ? (!importFrom || importFrom.trim().length === 0) : ""

        if ((importType === EXPORT_TYPE.INVENTORY_LEVELS && importFrom == IMPORT_FROM.CSV)
            && (!inventoryLocation || inventoryLocation.trim().length === 0)) {
            newErrors.inventoryLocation = props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["requiredFieldError"])
        }

        if (importFrom != IMPORT_FROM.INTEGRATION && (!file || file.trim().length === 0) ){
            newErrors.file = props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["requiredFieldError"])
        }

        if (importFrom == IMPORT_FROM.INTEGRATION && integration.trim().length === 0 ) {
            newErrors.integration = props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["requiredFieldError"])
        }

        if (isImportTypeUndefined) {
            newErrors.importType = props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["requiredFieldError"])
        }
        if (isImportFromUndefined) {
            newErrors.importFrom = props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["requiredFieldError"])
        }
        return newErrors
    }
    
    const handleCloseModal = (importStarted: boolean) => {
        props.onImportStartedCallback(importStarted)
    }

    const handleStartImport = async () => {
        const newErrors = findFormErrors()
        setErrors({
            importType: newErrors.importType,
            inventoryLocation: newErrors.inventoryLocation,
            file: newErrors.file,
            importFrom: newErrors.importFrom,
            integration: newErrors.integration,
        })
        
        if (!Object.values(newErrors).some(errorMsg => errorMsg !== "")) {
            if (form.importFrom == IMPORT_FROM.INTEGRATION){
                const newStockImport = createStockImportFromIntegrationDto(form)
                const res = await Service.postIntegration(form.integration,newStockImport)
                            
                if (isError(res)) {
                    throw new Error(res.message)
                } 
                props.onImportStartedCallback(true)
            }else {
                const newStockImport = createStockImportDto(form)
                const res = await Service.post(newStockImport)
                            
                if (isError(res)) {
                    throw new Error(res.message)
                } 
                props.onImportStartedCallback(true)
            }

        }
    }
    
    return (
        <Modal show={true} onHide={handleCloseModal} centered dialogClassName="stock-import-modal-50w">
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5>
                        {props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["title"])}
                    </h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StockNewImportForm
                    inventoryLocation={form.inventoryLocation}
                    importType={form.importType}
                    notes={form.notes}
                    errors={errors}
                    importFrom={form.importFrom}
                    integration = {form.integration}
                    onFormChangeCallback={handleFormFieldChangeCallback}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button className="mr-2 btn-modal-md" variant="secondary" onClick={() => handleCloseModal(false)}>
                    {props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["closeButton"])}
                </Button>
                <Button className="mr-2 btn-modal-lg" variant="primary" onClick={handleStartImport}>
                    {props.intl.formatMessage(STOCK_IMPORT_MODAL_MESSAGES["startImportButton"])}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default injectIntl(StockNewImportModalComponent)


// WEBPACK FOOTER //
// ./src/inventory/components/StockNewImportModalComponent.tsx